import request from '@/utils/request'
export function qryOrderInfo(query) {
  return request({
    url: '/api/orderInfo/qryOrderInfo',
    method: 'post',
    params: query
  })
}

// GET /api/orderInfo/Order 查询分订单
export function getSplitOrder(query) {
  return request({
    url: '/api/orderInfo/Order',
    params: query
  })
}

// POST /api/orderInfo/return 退款
export function refund(query) {
  return request({
    url: '/api/orderInfo/return',
    method: 'post',
    params: query
  })
}

// GET /api/orderInfo/exportExcel 导出Exce
export function exportExcel(query) {
  return request({
    url: '/api/orderInfo/exportExcel',
    params: query
  })
}
